// Metal Deck Configuration

export const APP_NAME = 'iMetalDeck';
export const APP_VERSION = '1.0.0';
export const APP_VERSION_POLICY = { currentVersion: APP_VERSION };

import type { ChartImage, DropdownOption } from '../shared';

export type APIPayload = {
  title: string;
  span: number;
  addedWeight: string;
  supports: number;
  sectionName: string;
  material: number;
  numTroughs: number;
  Pa: string; // pressure history csv
  td: string; // time history csv
  d0: number;
  v0: number;
};

export type ChartKey = 'chart_load' | 'chart_disp' | 'chart_rot' | 'chart_reaction' | 'chart_resistance' | 'chart_PM';

// prettier-ignore
export const SECTION_NAMES = [
  {value:'Deep Vercor, GA 26', label:'Deep Vercor, GA 26, Depth=1.3125, Width=4.5'},
  {value:'Deep Vercor, GA 24', label:'Deep Vercor, GA 24, Depth=1.3125, Width=4.5'},
  {value:'Deep Vercor, GA 22', label:'Deep Vercor, GA 22, Depth=1.3125, Width=4.5'},
  {value:'Deep Vercor, GA 20', label:'Deep Vercor, GA 20, Depth=1.3125, Width=4.5'},
  {value:'Shallow Vercor, GA 28', label:'Shallow Vercor, GA 28, Depth=0.5625, Width=3.0'},
  {value:'Shallow Vercor, GA 26', label:'Shallow Vercor, GA 26, Depth=0.5625, Width=3.0'},
  {value:'Shallow Vercor, GA 24', label:'Shallow Vercor, GA 24, Depth=0.5625, Width=3.0'},
  {value:'Shallow Vercor, GA 22', label:'Shallow Vercor, GA 22, Depth=0.5625, Width=3.0'},
  {value:'B Formlok, GA 22', label:'B Formlok, GA 22, Depth=1.5, Width=6.0'},
  {value:'B Formlok, GA 20', label:'B Formlok, GA 20, Depth=1.5, Width=6.0'},
  {value:'B Formlok, GA 18', label:'B Formlok, GA 18, Depth=1.5, Width=6.0'},
  {value:'B Formlok, GA 16', label:'B Formlok, GA 16, Depth=1.5, Width=6.0'},
  {value:'W2 Formlok, GA 22', label:'W2 Formlok, GA 22, Depth=2.0, Width=12.0'},
  {value:'W2 Formlok, GA 21', label:'W2 Formlok, GA 21, Depth=2.0, Width=12.0'},
  {value:'W2 Formlok, GA 20', label:'W2 Formlok, GA 20, Depth=2.0, Width=12.0'},
  {value:'W2 Formlok, GA 19', label:'W2 Formlok, GA 19, Depth=2.0, Width=12.0'},
  {value:'W2 Formlok, GA 18', label:'W2 Formlok, GA 18, Depth=2.0, Width=12.0'},
  {value:'W2 Formlok, GA 16', label:'W2 Formlok, GA 16, Depth=2.0, Width=12.0'},
  {value:'W3 Formlok, GA 22', label:'W3 Formlok, GA 22, Depth=3.0, Width=12.0'},
  {value:'W3 Formlok, GA 21', label:'W3 Formlok, GA 21, Depth=3.0, Width=12.0'},
  {value:'W3 Formlok, GA 20', label:'W3 Formlok, GA 20, Depth=3.0, Width=12.0'},
  {value:'W3 Formlok, GA 19', label:'W3 Formlok, GA 19, Depth=3.0, Width=12.0'},
  {value:'W3 Formlok, GA 18', label:'W3 Formlok, GA 18, Depth=3.0, Width=12.0'},
  {value:'W3 Formlok, GA 16', label:'W3 Formlok, GA 16, Depth=3.0, Width=12.0'},
  {value:'N Formlok, GA 22', label:'N Formlok, GA 22, Depth=3.0, Width=8.0'},
  {value:'N Formlok, GA 20', label:'N Formlok, GA 20, Depth=3.0, Width=8.0'},
  {value:'N Formlok, GA 18', label:'N Formlok, GA 18, Depth=3.0, Width=8.0'},
  {value:'N Formlok, GA 16', label:'N Formlok, GA 16, Depth=3.0, Width=8.0'},
  {value:'PLB-36/HSB-36, GA 22', label:'PLB-36/HSB-36, GA 22, Depth=1.5, Width=6.0'},
  {value:'PLB-36/HSB-36, GA 20', label:'PLB-36/HSB-36, GA 20, Depth=1.5, Width=6.0'},
  {value:'PLB-36/HSB-36, GA 18', label:'PLB-36/HSB-36, GA 18, Depth=1.5, Width=6.0'},
  {value:'PLB-36/HSB-36, GA 16', label:'PLB-36/HSB-36, GA 16, Depth=1.5, Width=6.0'},
  {value:'PLN-24/N-24, GA 22', label:'PLN-24/N-24, GA 22, Depth=3.0, Width=8.0'},
  {value:'PLN-24/N-24, GA 20', label:'PLN-24/N-24, GA 20, Depth=3.0, Width=8.0'},
  {value:'PLN-24/N-24, GA 18', label:'PLN-24/N-24, GA 18, Depth=3.0, Width=8.0'},
  {value:'PLN-24/N-24, GA 16', label:'PLN-24/N-24, GA 16, Depth=3.0, Width=8.0'},
  {value:'Vulcraft Type-B, GA 24', label:'Vulcraft Type-B, GA 24, Depth=1.5, Width=6.0'},
  {value:'Vulcraft Type-B, GA 22', label:'Vulcraft Type-B, GA 22, Depth=1.5, Width=6.0'},
  {value:'Vulcraft Type-B, GA 21', label:'Vulcraft Type-B, GA 21, Depth=1.5, Width=6.0'},
  {value:'Vulcraft Type-B, GA 20', label:'Vulcraft Type-B, GA 20, Depth=1.5, Width=6.0'},
  {value:'Vulcraft Type-B, GA 19', label:'Vulcraft Type-B, GA 19, Depth=1.5, Width=6.0'},
  {value:'Vulcraft Type-B, GA 18', label:'Vulcraft Type-B, GA 18, Depth=1.5, Width=6.0'},
  {value:'Vulcraft Type-B, GA 16', label:'Vulcraft Type-B, GA 16, Depth=1.5, Width=6.0'},
  {value:'Vulcraft Type-N, GA 22', label:'Vulcraft Type-N, GA 22, Depth=3.0, Width=8.0'},
  {value:'Vulcraft Type-N, GA 21', label:'Vulcraft Type-N, GA 21, Depth=3.0, Width=8.0'},
  {value:'Vulcraft Type-N, GA 20', label:'Vulcraft Type-N, GA 20, Depth=3.0, Width=8.0'},
  {value:'Vulcraft Type-N, GA 19', label:'Vulcraft Type-N, GA 19, Depth=3.0, Width=8.0'},
  {value:'Vulcraft Type-N, GA 18', label:'Vulcraft Type-N, GA 18, Depth=3.0, Width=8.0'},
  {value:'Vulcraft Type-N, GA 16', label:'Vulcraft Type-N, GA 16, Depth=3.0, Width=8.0'},
];

export const MATERIAL_OPTIONS: DropdownOption[] = [
  { value: 33, label: '33 ksi' },
  { value: 50, label: '50 ksi' }
];

export type APIResponse = {
  TA: number;
  Me: number;
  Xmax: number;
  tmax: number;
  Xmin: number;
  tmin: number;
  steel_weight: number;
  GWP: number;
  A: number;
  Av: number;
  I: number;
  S: number;
  Z: number;
  Depth: number;
  Width: number;

  K: number[];
  Tn: number[];
  Ru: number[];
  Xe: number[];
  duct: number[];
  rot: number[];
  V1: number[];
  V2: number[];

  charts?: Partial<Record<ChartKey, ChartImage>>;
};

// ============================================================================
// RESPONSE DISPLAY CONFIGURATION
// ============================================================================

import type { SectionConfig } from '../shared';
import { createElement as h } from 'react';

/**
 * Configuration for displaying response data
 * Defines what fields to show and how to format them
 */
export const RESPONSE_DISPLAY_CONFIG: SectionConfig<APIResponse>[] = [
  {
    title: 'Results',
    fields: [
      { label: 'Tributary Area', getValue: data => h('span', null, data.TA.toFixed(2), ' ft', h('sup', null, '2')) },
      {
        label: 'Stiffness',
        getValue: data => `[ ${data.K.map(value => value.toFixed(2))} ] kip/in`
      },
      {
        label: 'Effective Mass',
        getValue: data => h('span', null, data.Me.toFixed(3), ' lbs·sec', h('sup', null, '2'), '/in')
      },
      {
        label: 'Period',
        getValue: data => `[ ${data.Tn.map(value => value.toFixed(2))} ] msec`
      },
      {
        label: 'Resistance',
        getValue: data => `[ ${data.Ru.map(value => value.toFixed(2))} ] psi`
      },
      {
        label: 'Max Deflection',
        getValue: data => `${data.Xmax.toFixed(2)} in`
      },
      {
        label: 'Min Deflection',
        getValue: data => `${data.Xmin.toFixed(2)} in`
      },
      {
        label: 'Ductility',
        getValue: data => `[ ${data.duct.map(value => value.toFixed(2))} ]`
      },
      {
        label: 'Rotation',
        getValue: data => `[ ${data.rot.map(value => value.toFixed(2))} ] deg`
      },
      {
        label: 'Steel Weight',
        getValue: data => `${data.steel_weight.toFixed(0)} lbs`
      },
      {
        label: 'GWP',
        getValue: data => `${data.GWP.toFixed(0)} kg CO2e`
      },
      {
        label: 'Support Reaction V1',
        getValue: data => `[ ${data.V1.map(value => value.toFixed(2))} ] kips`
      },
      {
        label: 'Support Reaction V2',
        getValue: data => `[ ${data.V2.map(value => value.toFixed(2))} ] kips`
      }
    ]
  },
  {
    title: 'Section Properties',
    fields: [
      {
        label: 'Area (A)',
        getValue: data => h('span', null, data.A.toFixed(4), ' in', h('sup', null, '2'))
      },
      {
        label: 'Shear Area (Av)',
        getValue: data => h('span', null, data.Av.toFixed(4), ' in', h('sup', null, '2'))
      },
      {
        label: 'Moment of Inertia (I)',
        getValue: data => h('span', null, data.I.toFixed(4), ' in', h('sup', null, '4'))
      },
      {
        label: 'Section Modulus (S)',
        getValue: data => h('span', null, data.S.toFixed(4), ' in', h('sup', null, '3'))
      },
      {
        label: 'Plastic Section Modulus (Z)',
        getValue: data => h('span', null, data.Z.toFixed(4), ' in', h('sup', null, '3'))
      },
      {
        label: 'Metal Deck Depth',
        getValue: data => h('span', null, data.Depth.toFixed(4), ' in')
      },
      {
        label: 'Metal Deck Width',
        getValue: data => h('span', null, data.Width.toFixed(4), ' in')
      }
    ]
  }
];
